import { Link } from 'react-router-dom';

export default function ComparisonSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            Agent <span className="text-accent-500">Comparison</span> &amp;
            <br />
            Spreadsheet <span className="text-accent-500">Guide</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mt-4 leading-relaxed">
            Compare mulebuy spreadsheet agents side by side. Find the most reliable options with transparent data and verified reviews.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
          <div className="lg:w-3/5">
            <div className="bg-white rounded-2xl p-5 md:p-7">
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-4">
                Mulebuy Agents Comparison
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200/70">
                      <th className="text-left py-2.5 px-2 text-foreground-600 font-medium text-xs whitespace-nowrap">Agent</th>
                      <th className="text-left py-2.5 px-2 text-foreground-600 font-medium text-xs whitespace-nowrap">Fees</th>
                      <th className="text-left py-2.5 px-2 text-foreground-600 font-medium text-xs whitespace-nowrap">Speed</th>
                      <th className="text-left py-2.5 px-2 text-foreground-600 font-medium text-xs whitespace-nowrap">Reliability</th>
                      <th className="text-left py-2.5 px-2 text-foreground-600 font-medium text-xs whitespace-nowrap">Spreadsheet Support</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-background-100">
                      <td className="py-3 px-2 font-semibold text-foreground-900 whitespace-nowrap">Agent Alpha</td>
                      <td className="py-3 px-2 text-foreground-700 whitespace-nowrap">3-5%</td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-accent-500 font-medium">Fast</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-primary-500 font-medium">High</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><i className="ri-check-line text-accent-500"></i> Full</td>
                    </tr>
                    <tr className="border-b border-background-100">
                      <td className="py-3 px-2 font-semibold text-foreground-900 whitespace-nowrap">Agent Beta</td>
                      <td className="py-3 px-2 text-foreground-700 whitespace-nowrap">4-6%</td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-secondary-500 font-medium">Medium</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-primary-500 font-medium">High</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><i className="ri-check-line text-accent-500"></i> Partial</td>
                    </tr>
                    <tr className="border-b border-background-100">
                      <td className="py-3 px-2 font-semibold text-foreground-900 whitespace-nowrap">Agent Gamma</td>
                      <td className="py-3 px-2 text-foreground-700 whitespace-nowrap">2-4%</td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-accent-500 font-medium">Fast</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-secondary-500 font-medium">Medium</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><i className="ri-check-line text-accent-500"></i> Full</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-2 font-semibold text-foreground-900 whitespace-nowrap">Agent Delta</td>
                      <td className="py-3 px-2 text-foreground-700 whitespace-nowrap">5-7%</td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-accent-500 font-medium">Fast</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><span className="text-primary-500 font-medium">Very High</span></td>
                      <td className="py-3 px-2 whitespace-nowrap"><i className="ri-check-line text-accent-500"></i> Full</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-4 pt-3 border-t border-background-100">
                <Link
                  to="/mulebuy-agents-comparison"
                  className="text-xs text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap"
                >
                  View full comparison &rarr;
                </Link>
              </div>
            </div>
          </div>

          <div className="lg:w-2/5 flex flex-col gap-5">
            <Link
              to="/what-is-mulebuy-spreadsheet"
              className="group relative rounded-2xl p-6 md:p-7 bg-accent-100/80 cursor-pointer hover:bg-accent-100 transition-colors"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-200 text-accent-800 text-xs font-medium whitespace-nowrap">
                    SEO Guide
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mt-3 leading-snug">
                    What is Mulebuy Spreadsheet?
                  </h3>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                    Complete guide explaining what a mulebuy spreadsheet is, how it works, and why buyers rely on it.
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm text-foreground-900 font-medium mt-3 whitespace-nowrap">
                    Read Guide
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                </div>
              </div>
            </Link>

            <Link
              to="/best-mulebuy-spreadsheets"
              className="group relative rounded-2xl p-6 md:p-7 bg-secondary-100/80 cursor-pointer hover:bg-secondary-100 transition-colors"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-200 text-secondary-800 text-xs font-medium whitespace-nowrap">
                    Best Lists 2026
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mt-3 leading-snug">
                    Best Mulebuy Spreadsheet List
                  </h3>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                    Updated 2026 list of the best mulebuy spreadsheets with trust scores, features, and ratings.
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm text-foreground-900 font-medium mt-3 whitespace-nowrap">
                    View List
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}